import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

// bank + no (N° Fiche) requis cote serveur — no n'est unique que par
// bank+tirage+jour, pas sur toute la company. tirage optionnel (code loterie,
// affine si plusieurs loteries partagent le meme no ce jour-la). date
// optionnelle, defaut serveur = aujourd'hui (heure Port-au-Prince).
// Renvoie { date, count, rows } — chaque row porte deja le detail complet
// (lignes + gain + numero gagnant + statut paiement), pas besoin d'un 2e appel.
export const searchPayTickets = ({ bank, tirage, no, date }) =>
  apiRequest(`/tickets/pay-ticket/search/${toQuery({ bank, tirage, no, date })}`);

export const payTicket = (ticketId) =>
  apiRequest(`/tickets/pay-ticket/${ticketId}/`, { method: 'POST' });
